import React from "react";
import StatCards from "./StatCards";
import NoticePortal from "../NoticePortal";
import useNotice from "../Hooks/useNotice";
import AtRiskSuspendedPharmacyCard from "./AtRiskSuspendedPharmacyCard";
import ClaimsActivityCard from "./ClaimsActivityCard";

const Index = (props) => {
  const { notice } = useNotice();

  return (
    <div className="dashboard__grid">
      <StatCards
        user_name={props.user.name}
        total_claims_count={props.total_claims_count}
        user_email={props.user.email}
        user_2fa={props.user.twofa}
        user_settings_path={props.user_settings_path}
        organization={props.organization}
        entity_path={props.entity_path}
        entities_count={props.entities_count}
        cp_count={props.cp_count}
        conforming_claims_count={props.conforming_claims_count}
      />
      <AtRiskSuspendedPharmacyCard organizationId={props.organization} />

      <ClaimsActivityCard
        pharmacySubmissionPath={props.pharmacy_submission_path}
        pharmacyEncounterSubmissionPath={props.pharmacy_encounter_submission_path}
        medicalSubmissionPath={props.medical_submission_path}
        medicalEncounterSubmissionPath={props.medical_encounter_submission_path}
        organizationId={props.organization}
      />
      <NoticePortal details={notice} />
    </div>
  );
};

export default Index;
